import {
  FETCH_ALL_USERS_FAILURE,
  FETCH_ALL_USERS_REQUEST,
  FETCH_ALL_USERS_SUCCESS,
} from "./actionsTypes";
import { AllUsers } from "./types";

export const fetchAllUsersRequest = (url: string) => ({
  type: FETCH_ALL_USERS_REQUEST,
  url,
});

export const fetchAllUsersSuccess = (allUsers: AllUsers[]) => ({
  type: FETCH_ALL_USERS_SUCCESS,
  payload: { allUsers },
});
export const fetchAllUsersFailure = (error: string) => ({
  type: FETCH_ALL_USERS_FAILURE,
  payload: error,
});
